import { useTranslation } from 'react-i18next'
import styles from './VoterMyCandidacy.module.scss'

export const VoterMyCandidacy = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <h1 className={styles['header']}>{t('pages.myCandidacy')}</h1>
    </div>
  )
}
